import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: './app-menu.component.html'
})
export class AppMenuComponent {
  // 接收父组件传入的菜单数据
  @Input() menuItems: any[] = [];
   // 定义输出事件，用于向外部传递点击信息
  @Output() menuItemClick = new EventEmitter<any>(); 
  @Input() activeId: string = '';

  handleMenuItemClick(item: any) {
    // 暴力传递：直接通过输出事件将点击的菜单数据发送给外部
    this.menuItemClick.emit(item); 
    
  }
}
    